<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row" v-if="landResult">
                            <div class="col-12 table-responsive">
                                <table class="table table-sm table-striped comparison-table" style="min-width: 900px">
                                    <tr>
                                        <th rowspan="2" class="text-center">Таккослаш элементлари</th>
                                        <th rowspan="2" class="text-center">Таккослаш объекти</th>
                                        <th :colspan="landResult.analogs.length" class="text-center">
                                            Аналоглар
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-center" v-for="(analog,index) in landResult.analogs" :key="index" style="position: relative">
                                            аналог {{index + 1}}
                                            <div class="height-auto" v-if="hasPermission('REAL_ESTATE_LAND_ANALOGS_SELECT')">
                                              <v-select
                                               :options="analogs"
                                               label="name"
                                               :clearable="false"
                                               v-model="analog.apiAnalog"
                                              >
                                                <template slot="option" slot-scope="option" v-if="option && option.name">
                                                  <div v-html="option.name" style="font-weight: bold"></div>
                                                  <template v-if="option.totalArea">
                                                    <div>Умумий майдон {{option.totalArea}} м²</div>
                                                  </template>
                                                  <template>
                                                    <div>{{option.price | currency('', 2, { thousandsSeparator: ' ' }) }} {{option.priceUnit.symbol}}</div>
                                                  </template>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                              </v-select>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                      <td class="text-center">Сотилиш баҳоси. АҚШ доллар </td>
                                        <td></td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            <span>{{analog.priceCurrency | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Сотилиш бахоси. Сум</td>
                                        <td></td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                                <span>
                                                    {{analog.priceUzs | currency('', 2, { thousandsSeparator: ' ' })}}
                                                </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" rowspan="2">Фойдаланилган маълумотлар манбаи</td>
                                        <td>Манба</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.source}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Маълумотлар баъзасида сақланаётган хавола (ссылка)</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            эълон рақами: {{analog.id}}
                                            <br />
                                            <a :href="`https://e-rieltor.uz/products/product/${analog.id}`" target="_blank">https://e-rieltor.uz/products/product/{{analog.id}}</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowspan="4" class="text-center" v-if="landResult.coefficient && landResult.coefficient.buildingPeriod">
                                          Даврга нисбатан
                                        </td>
                                        <td v-else rowspan="5" class="text-center">
                                          Бозор шартлари
                                        </td>
                                        <td class="text-center">
                                          Савдога куйилган ёки сотилиш санаси
                                          <div v-if="landResult.coefficient && landResult.coefficient.buildingPeriod">
                                            {{landResult.salesDate}}
                                          </div>
                                        </td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.salesDate}}
                                        </td>
                                    </tr>
                                    <template v-if="landResult.coefficient && landResult.coefficient.buildingPeriod">
                                      <tr>
                                        <td class="text-center">
                                          <span v-if="landResult.coefficient && landResult.coefficient.buildingPeriod">{{landResult.coefficient.buildingPeriod}}</span>
                                        </td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                          {{analog.coefficient.buildingPeriod}}
                                        </td>
                                      </tr>
                                    </template>
                                    <template v-else>
                                      <tr>
                                        <td class="text-center">Марказий банк. АҚШ доллар</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                          {{analog.currencyRate}}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="text-center">Бахолаш санасига 1 АКШ доллари </td>
                                        <td colspan="3" class="text-right">{{landResult.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      </tr>
                                    </template>
                                    <tr>
                                        <td class="text-center">Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.fix.exchangeRate | currency('', 3, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.exchangeRateFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" :rowspan="landResult.fix && landResult.fix.areaAnalogCoefficient > 0 ? 5:4">Умумий ер майдонига тузатиш</td>
                                        <td class="text-center">{{landResult.totalArea}}</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.totalArea}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Ер участкаси 1 м.кв. Баҳоси</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <template v-if="landResult.fix && landResult.fix.areaAnalogCoefficient > 0">
                                        <tr>
                                            <td>Тузатиш коеффициенти: {{landResult.fix.areaAnalogCoefficient}}</td>
                                            <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                                {{analog.fix.areaAnalogCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td>Ер участкасининг катта кичиклигига тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.fix.totalArea | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.totalAreaFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" rowspan="3">Сотиш шарти</td>
                                        <td>Олинган манба ва элон раками</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.source}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.fix.source}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.sourceFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" rowspan="4">Фойдаланиш турига караб тузатиш</td>
                                        <td>
                                            <div v-if="landResult.cadastreType">
                                                <span v-if="landResult.cadastreType === 'Notorious'">Нотурар жой</span>
                                                <span v-else-if="landResult.cadastreType === 'Residential'">Турар жой</span>
                                            </div>
                                            <div v-else>{{landResult.buildingType.name}}</div>
                                        </td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            <div v-if="analog.cadastreType">
                                                <span v-if="analog.cadastreType === 'Notorious'">Нотурар жой</span>
                                                <span v-else-if="analog.cadastreType === 'Residential'">Турар жой</span>
                                            </div>
                                            <div v-else>{{getBuildingType(analog.categoryCode)[0].name}}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{landResult.categoryCoefficient}} %</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.categoryCoefficient}} %
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.fix.category | currency('', 2, { thousandsSeparator: ' ' })}} %
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.categoryFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" :rowspan="isRegionFixCalculated ? 9 : 3">Жойлашган ерига караб тузатиш</td>
                                        <td>{{landResult.regionName}}</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.regionName}}
                                        </td>
                                    </tr>
                                  <template v-if="isRegionFixCalculated">
                                    <tr>
                                      <td>Марказдан узоқлиги {{landResult.regionFixCalculated.distanceFromDistrict | currency('', 2, { thousandsSeparator: ' ' })}} м</td>
                                      <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                        {{ analog.regionFixCalculated.distanceFromDistrict | currency('', 2, { thousandsSeparator: ' ' })}} м
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">Марказдан узоқлигига коэффициент {{landResult.regionFixCalculated.centralRoad | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                        {{ analog.regionFixCalculated.centralRoad | currency('', 2, { thousandsSeparator: ' ' })}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Алохида кулайлик {{landResult.specialComfort}}</td>
                                      <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                        {{ analog.specialComfort}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">Қулайлик учун коэффициент {{landResult.regionFixCalculated.addressAuthority | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                        {{ analog.regionFixCalculated.addressAuthority | currency('', 2, { thousandsSeparator: ' ' })}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">Туман учун коэффициент {{landResult.regionFixCalculated.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                        {{ analog.regionFixCalculated.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">Жойлашган жойи коэффициенти (йиғинди) {{landResult.regionFixCalculated.total | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                        {{ analog.regionFixCalculated.total | currency('', 2, { thousandsSeparator: ' ' })}}
                                      </td>
                                    </tr>
                                  </template>
                                    <tr v-if="landResult.regionCoefficient">
                                        <td>{{landResult.regionCoefficient}} %</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.regionCoefficient}} %
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                          {{analog.fix.region | currency('', 3, { thousandsSeparator: ' ' })}} {{isRegionFixCalculated ? '' : '%'}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" rowspan="3">Топширилаётган мулк хукуки</td>
                                        <td>Эгалик</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            Эгалик
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            1
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" rowspan="5">Молиялаштириш шартлари</td>
                                        <td>Олдиндан тулов</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            Олдиндан тулов
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Бўлиб тўлаш йилига (фоизи)</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            0
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Бўлиб тўлаш муддати ой</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            0
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            1
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" rowspan="3">Хариддан кейинги харажатлар </td>
                                        <td>Мавжуд</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            Мавжуд
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Тузатиш</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            1
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center"><b>Тузатишлар сони</b></td>
                                        <td></td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.totalFixes}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center"><b>Коффициент улушлари</b></td>
                                        <td></td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.totalFixesCoefficient}} %
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center"><b>Тузатишларни киритгандан кейинги</b>
                                            <br/><b>улушларни хисобга олгандаги бахоси</b></td>
                                        <td></td>
                                        <td v-for="(analog,index) in landResult.analogs" :key="index" class="text-center">
                                            {{analog.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center"><b>1 м.кв ер участкаси бахоси, сумда</b></td>
                                        <td colspan="4" class="text-center">
                                            <b>{{landResult.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center"><b>Баҳоланаётган объект майдони</b></td>
                                        <td colspan="4" class="text-center">
                                            <b>{{landResult.totalArea}}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center"><b>Жами ер участкаси бахоси</b></td>
                                        <td colspan="4" class="text-center">
                                            <b>{{landResult.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-12">
                                <div class="text-center">
                                    <span class="no-data mt-5 mb-5">{{$t("messages.list.empty")}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import AdvancedFilter from '@/shared/filters/advancedFilter';
    export default {
        props: {
            landResult: Object
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                realEstateId: ((this.$route.params.hasOwnProperty('id') && this.$route.params.id) ? this.$route.params.id : null),
                buildingTypes: [],
                filterBuildingType: new AdvancedFilter(),
                analogs: []
            }
        },
        methods: {
            init() {
                const vm = this;
                this.filterBuildingType.onlyParentLookUp = true
                const promises = [
                    this.$http.post('building-type/list', this.filterBuildingType)
                ];

                if (this.realEstateId && this.realEstateId > 0) {
                  promises.push(this.$http.get(`admin/new-real-estate/search-land-analog/${this.realEstateId}`));
                }

                Promise.all(promises).then(function (values) {
                    if (values[0].data !== "" && values[0].data.data && values[0].data.data.length > 0) {
                        vm.buildingTypes = values[0].data.data;
                    }

                    if (values.length >= 2) {
                      const analogData = values[1].data;
                      if (analogData.data && analogData.data.map) {
                        vm.analogs = analogData.data.map((analog) => {
                          analog.name = analog.id + "#" + analog.name;
                          return analog;
                        });
                      }
                    }
                })
            },
            getBuildingType(code) {
                return this.buildingTypes.filter(type => type.code === code).map(type =>({code: type.code, name:type.name}));
            }
        },
        computed: {
          isRegionFixCalculated() {
            return this.landResult && this.landResult.regionFixCalculated && this.landResult.regionFixCalculated.regionCoefficient
          }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>

    .comparison-table {
        font-size: 14px;
    }
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>